import { RelatorioAtividadeDto } from '@/modules/reports/application/relatorios-atividades.service';

export interface PrazoEnvioInfo {
  isForaPrazo: boolean;
  prazoFinalLabel: string;
  enviadoEmLabel?: string;
}

function parseMes(mes: number | string | undefined): number | null {
  if (mes == null) return null;
  const n = typeof mes === 'string' ? parseInt(mes, 10) : mes;
  return Number.isFinite(n) ? n : null;
}

function formatarDataPtBr(d: Date): string {
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/**
 * Prazo final de envio do relatório.
 * - Regra geral: último dia do mês seguinte (ex.: jan/2026 → 28/02/2026).
 * - Novembro e dezembro: ambos até 20/12 do mesmo ano do relatório.
 */
export function getPrazoFinalEnvioUTC(mes: number | string | undefined, ano: number): number | null {
  const mesNumero = parseMes(mes);
  if (!mesNumero || !Number.isFinite(ano)) return null;

  // Novembro e dezembro: prazo unificado em 20/12 do ano do relatório.
  if (mesNumero === 11 || mesNumero === 12) {
    return Date.UTC(ano, 11, 20, 23, 59, 59, 999);
  }

  // `mesNumero` é 1-12. Em Date.UTC: monthIndex é 0-11.
  // Queremos o último dia do mês seguinte -> mêsIndex = mesNumero + 1, day = 0.
  return Date.UTC(ano, mesNumero + 1, 0, 23, 59, 59, 999);
}

export function getPrazoEnvioInfo(relatorio: Pick<RelatorioAtividadeDto, 'mes' | 'ano' | 'dataEnvio'>): PrazoEnvioInfo | null {
  const prazoFinalUtcMs = getPrazoFinalEnvioUTC(relatorio.mes, relatorio.ano);
  if (!prazoFinalUtcMs) return null;
  if (!relatorio.dataEnvio) return null;

  const enviadoEm = new Date(relatorio.dataEnvio);
  if (isNaN(enviadoEm.getTime())) return null;

  const isForaPrazo = enviadoEm.getTime() > prazoFinalUtcMs;
  const prazoFinalLabel = formatarDataPtBr(new Date(prazoFinalUtcMs));
  const enviadoEmLabel = formatarDataPtBr(enviadoEm);

  return { isForaPrazo, prazoFinalLabel, enviadoEmLabel };
}
